/**
 * EnvironmentalMeasurement Create Page
 * Registro de uma nova medição ambiental (#351)
 */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/material';
import { PageShell } from '../../components';
import { environmentalMeasurementService } from '../../services/environmentalMeasurementService';
import { EnvironmentalMeasurementFormData } from '../../types/environmentalMeasurement';
import { EnvironmentalMeasurementForm } from './components/EnvironmentalMeasurementForm';

export const EnvironmentalMeasurementCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: EnvironmentalMeasurementFormData) => {
    try {
      setLoading(true);
      setError(null);
      await environmentalMeasurementService.createEnvironmentalMeasurement(data);
      navigate('/environmental-measurements');
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Erro ao registrar medição ambiental');
    } finally {
      setLoading(false);
    }
  };

  return (
    <PageShell
      breadcrumbs={[
        { label: 'Início', path: '/' },
        { label: 'Medições Ambientais', path: '/environmental-measurements' },
        { label: 'Nova Medição' },
      ]}
      title="Registrar Medição Ambiental"
      subtitle="Informe o valor medido em campo para um risco já aplicado"
    >
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      <EnvironmentalMeasurementForm
        onSubmit={handleSubmit}
        onCancel={() => navigate('/environmental-measurements')}
        loading={loading}
      />
    </PageShell>
  );
};

export default EnvironmentalMeasurementCreatePage;
